import React from "react";
import { motion } from "framer-motion";
import ShaderBackground from "./ShaderBackground";
import "../assets/css/header.scss";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12, ease: "easeOut" },
  }),
};

const Header = () => {
  return (
    <header id="header" className="header">
      <div className="aurora-bg" aria-hidden="true">
        <span className="aurora aurora-1"></span>
        <span className="aurora aurora-2"></span>
        <span className="aurora aurora-3"></span>
      </div>

      <ShaderBackground />

      <div className="container header-container">
        <motion.div
          className="header-text"
          initial="hidden"
          animate="visible"
        >
          <motion.span
            className="handle"
            custom={0}
            variants={fadeUp}
          >
            <span className="dot"></span>~/EnigmaTech
            <span className="cursor">_</span>
          </motion.span>

          <motion.h1 custom={1} variants={fadeUp}>
            Derryck Dowuona
          </motion.h1>

          <motion.h2 custom={2} variants={fadeUp}>
            Full-Stack Web Developer
          </motion.h2>

          <motion.p className="summary" custom={3} variants={fadeUp}>
            With professional skills in front-end and back-end development, I
            am passionate about translating client needs into
            innovative, state-of-the-art web solutions. I also enjoy working
            in collaborative environments, utilizing my skills to effectively
            contribute to team projects.
          </motion.p>

          <motion.div className="cta-row" custom={4} variants={fadeUp}>
            <a href="#projects" className="btn btn-primary">
              View My Work
            </a>
            <a href="#contact" className="btn">
              Get In Touch
            </a>
          </motion.div>

          <motion.div className="social-row" custom={5} variants={fadeUp}>
            <a
              href="https://github.com/EnigmaTechx"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <i className="fa fa-github"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/derryckniinoidowuona"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fa fa-linkedin"></i>
            </a>
            <a href="mailto:derryckdxd@gmail.com" aria-label="Email">
              <i className="fa fa-envelope"></i>
            </a>
          </motion.div>
        </motion.div>

        <motion.div
          className="header-photo"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <div className="photo-glow"></div>
          <div className="photo-frame">
            <span className="corner corner-tl"></span>
            <span className="corner corner-tr"></span>
            <span className="corner corner-bl"></span>
            <span className="corner corner-br"></span>
            <div className="photo"></div>
            <div className="scanline"></div>
          </div>
          <div className="status-badge">
            <span className="status-dot"></span>
            Available for work
          </div>
        </motion.div>
      </div>
    </header>
  );
};

export default Header;
